//##### AVATAR ASSETS ######
//##########################
import boy1 from "./avatars/boy1.webp";
import boy2 from "./avatars/boy2.webp";
import boy3 from "./avatars/boy3.webp";
import girl1 from "./avatars/girl1.webp";
import girl2 from "./avatars/girl2.webp";
import girl3 from "./avatars/girl3.webp";
import girl4 from "./avatars/girl4.webp";
import girl5 from "./avatars/girl5.webp";

//##### BACKGROUND ASSETS ######
//##############################
import alienPlanet from "./backgrounds/alien-planet.webp";
import bareBeach from "./backgrounds/bare-beach.webp";
import cherryBlossoms from "./backgrounds/cherry-blossoms.webp";
import deepForest from "./backgrounds/deep-forest.webp";
import desert from "./backgrounds/desert.webp";
import dinosaurs from "./backgrounds/dinosaurs.webp";
import fieldCliff from "./backgrounds/field-cliff.webp";
import fieldHill from "./backgrounds/field-hill.webp";
import field from "./backgrounds/field.webp";
import forestAlt from "./backgrounds/forest-alt.webp";
import forest from "./backgrounds/forest.webp";
import jungleIsland from "./backgrounds/jungle-island.webp";
import jungle from "./backgrounds/jungle.webp";
import nightField from "./backgrounds/night-field.webp";
import nightForest from "./backgrounds/night-forest.webp";
import nightTown from "./backgrounds/night-town.webp";
import openField from "./backgrounds/open-field.webp";
import ruralField from "./backgrounds/rural-field.webp";
import stream from "./backgrounds/stream.webp";
import sunsetValley from "./backgrounds/sunset-valley.webp";
import training from "./backgrounds/training.webp";
import tropicalBeach from "./backgrounds/tropical-beach.webp";
import valley from "./backgrounds/valley.webp";

//##### ICON ASSETS ######
//########################
import pixelPokeball from "./icons/8bitpokeball.webp";
import attackSpecial from "./icons/attack-special.png";
import attack from "./icons/attack.png";
import defenseSpecial from "./icons/defense-special.png";
import defense from "./icons/defense.png";
import dragon from "./icons/dragon.png";
import electric from "./icons/electric.png";
import fire from "./icons/fire.png";
import fighting from "./icons/fighting.png";
import ghost from "./icons/ghost.png";
import grass from "./icons/grass.png";
import heart from "./icons/heart.png";
import ice from "./icons/ice.png";
import dark from "./icons/dark.png";
import poison from "./icons/poison.png";
import search from "./icons/search.png";
import speed from "./icons/speed.png";
import thumbsup from "./icons/thumbsup.png";
import water from "./icons/water.png";
import normal from "./icons/normal.png";
import flying from "./icons/flying.png";
import ground from "./icons/ground.png";
import rock from "./icons/rock.png";
import psychic from "./icons/psychic.png";
import bug from "./icons/bug.png";
import fairy from "./icons/fairy.png";
import steel from "./icons/steel.png";
import fullscreen from "./icons/fullscreen.png";
import normalscreen from "./icons/normalscreen.png";

//##### GEN. IMAGE ASSETS ######
//##############################
import backpack from "./img/backpack.webp";
import peekvee from "./img/eevee-bottom.webp";
import pokeball from "./img/pokeball.webp";
import pokedex from "./img/pokedex.png";
import loading from "./img/loading.gif";
import opengraph from "./img/opengraph.jpg";

//##### LOGO ASSETS ########
//##########################
import logo from "./logo/logo.webp";

//##### SPRITE ASSETs ######
//##########################
import bulbasaur from "./sprite/bulbasaur.webp";
import eevee from "./sprite/eevee.webp";
import pikachu from "./sprite/pikachu.webp";
import snorlax from "./sprite/snorlax.webp";
import squirtle from "./sprite/squirtle.webp";

export const avatars = {
  boy1,
  boy2,
  boy3,
  girl1,
  girl2,
  girl3,
  girl4,
  girl5,
};

export const backgrounds = [
  alienPlanet, //0
  bareBeach, //1
  cherryBlossoms, //2
  deepForest, //3
  desert, //4
  dinosaurs, //5
  fieldCliff, //6
  fieldHill, //7
  field, //8
  forestAlt, //9
  forest, //10
  jungleIsland, //11
  jungle, //12
  nightField, //13
  nightForest, //14
  nightTown, //15
  openField, //16
  ruralField, //17
  stream, //18
  sunsetValley, //19
  training, //20
  tropicalBeach, //21
  valley, //22
];

export const icons = {
  pixelPokeball,
  attackSpecial,
  defenseSpecial,
  defense,
  dragon,
  fire,
  fighting,
  ghost,
  grass,
  heart,
  ice,
  dark,
  poison,
  search,
  speed,
  thumbsup,
  water,
  attack,
  electric,
  normal,
  flying,
  ground,
  rock,
  psychic,
  bug,
  fairy,
  steel,
  normalscreen,
  fullscreen,
};

export const imgAssets = {
  backpack,
  peekvee,
  pokeball,
  pokedex,
  logo,
  loading,
  opengraph,
};

export const sprites = {
  pikachu,
  bulbasaur,
  squirtle,
  eevee,
  snorlax,
};
